import React, { useEffect, FC } from "react";
import { Table, Button, Input, Tooltip } from "antd";
import { YHModal } from "@/components/YHModal";
import { useMaintenanceDetailsModel } from "./maintenanceDetailsModels";
import { ColumnsType } from "antd/lib/table";
import { YhBox } from "@/components/YhBox";
import { YhBut } from "@/components/YhButton";
import { IItemDetail } from "@/views/base/item/itemType";
import { formatIntPoint, repairFormatNum, formatNum } from "@/utils/utils";
import { components } from "@/components/YHEditTable/editTable";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { PlusSquareOutlined } from "@ant-design/icons";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";
import YhTootip from "@/components/YhTootip";

enum OPT_TYPE {
    ADD = 1,
    REMOVE = 2
}
export const ItemModal: FC<RouterParamType> = ({ id, mode }) => {
    const { selectedNavId, replaceNav } = useNavModel();
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();
    const {
        itemModel: visible,
        searchWorkItemData,
        workItemDataSource,
        addDataItemSource,
        initPgCfg,
        workItemPgCfg,
        detailLookForm,
        detailEditForm,
        detailAddForm,
        SBcode,
        isThreeService,
        setItemModel,
        workItemloadData,
        resetWorkItemloadData,
        setSearchWorkItemData,
        setAddDataItemSource,
        setWorkItemDataSource,
        transformsToPoItemDetailList,
        detailItemAddList,
        detailItemEditList
    } = useMaintenanceDetailsModel();
    const onOk = () => {
        transformsToPoItemDetailList(mode)
        onCancel()
    }
    const typeForm: any = {
        add: detailAddForm,
        edit: detailEditForm,
        look: detailLookForm
    }
    const onCancel = () => {
        setItemModel(false);
        setAddDataItemSource([]);
        setSearchWorkItemData({})
    };
    useEffect(() => {
        workItemloadData(initPgCfg, { brandName: typeForm[mode]?.brandName })
        setSearchWorkItemData({ brandName: typeForm[mode]?.brandName })
    }, [visible])
    const column = (optype: number) => [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '项目编码',
            width: 120,
            dataIndex: 'code',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '项目名称',
            width: 140,
            dataIndex: 'name',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '品牌',
            width: 120,
            dataIndex: 'brandName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '工时',
            width: 100,
            dataIndex: 'workHours',
            editable: true,
        }, {
            title: '单价',
            width: 100,
            dataIndex: 'price',
            editable: true,
        }, {
            title: '工时费',
            width: 100,
            dataIndex: 'amount',
        }, {
            title: '备注',
            width: 120,
            dataIndex: 'note',
            editable: true
        }, {
            title: '操作',
            width: 60,
            fixed: "right",
            align: "center",
            render: (text: any, record: any) => optype === OPT_TYPE.ADD ? (
                <YhBut
                    type="add"
                    txt="添加"
                    click={() => add(record)}
                    disabled={
                        !!addDataItemSource.find(item => item.id === record.id) ||
                        !!(mode === 'add' ? detailItemAddList : detailItemEditList).find(item => item.itemCode === record.code)
                    }
                />
            ) : (
                <YhBut
                    type="delete"
                    txt="删除"
                    click={() => remove(record)}
                />
            )
        }
    ];
    const newSelectColumns = (optType: number) =>
        column(optType).map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IItemDetail, rowIndex: number) => ({
                    colIndex: index,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col.editType,
                    editable: col?.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: optType === OPT_TYPE.ADD ? notHandleSave : handleSave,
                }),
            }
        })

    const roleColumns = (optType: number) => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "order", "roleCodes": roles };
        return getRoleColumns("order", "新增项目", newSelectColumns(optType), params);
    };

    const add = async (record: IItemDetail) => {
        setAddDataItemSource(origin => [...origin, { ...record, threeGuaranteesId: isThreeService ? SBcode : undefined, }])
    }
    const remove = async (record: IItemDetail) => {
        const filterAddDataSource = addDataItemSource.filter(item => item.id !== record.id)
        setAddDataItemSource(filterAddDataSource)
    }
    const notHandleSave = (row: IItemDetail) => {
        let { workHours, price } = row;
        workHours = +formatIntPoint(workHours);
        price = +formatNum(price);
        let newRow = {
            ...row,
            amount: +repairFormatNum(workHours * price)
        }
        const index = workItemDataSource.findIndex((item) => row.id === item.id);
        const item = workItemDataSource[index];
        workItemDataSource.splice(index, 1, { ...item, ...newRow });
        setWorkItemDataSource([...workItemDataSource])
    }
    const handleSave = (row: IItemDetail) => {
        let { workHours, price } = row;
        workHours = +formatIntPoint(workHours);
        price = +formatNum(price);
        let newRow = {
            ...row,
            amount: +repairFormatNum(workHours * price)
        }
        const index = addDataItemSource.findIndex((item) => row.id === item.id);
        const item = addDataItemSource[index];
        addDataItemSource.splice(index, 1, { ...item, ...newRow });
        setAddDataItemSource([...addDataItemSource])
    }
    const rightChildren = <div className="flex">
        <Input
            allowClear
            datatype="round"
            className="border-r-16 mr-10"
            value={searchWorkItemData.brandName}
            style={{ width: "150px" }}
            onChange={(e) => { setSearchWorkItemData({ ...searchWorkItemData, brandName: e.target.value }) }}
            onBlur={(e) => { setSearchWorkItemData({ ...searchWorkItemData, brandName: e.target.value?.trim() }) }}
            onPressEnter={() => workItemloadData(initPgCfg)}
            placeholder="品牌"
        />
        <Input
            allowClear
            datatype="round"
            className="border-r-16 mr-10"
            value={searchWorkItemData.itemCode}
            style={{ width: "150px" }}
            onChange={(e) => { setSearchWorkItemData({ ...searchWorkItemData, itemCode: e.target.value }) }}
            onBlur={(e) => { setSearchWorkItemData({ ...searchWorkItemData, itemCode: e.target.value?.trim() }) }}
            onPressEnter={() => workItemloadData(initPgCfg)}
            placeholder="项目编码"
        />
        <Input
            allowClear
            datatype="round"
            className="border-r-16 mr-10"
            value={searchWorkItemData.itemName}
            style={{ width: "150px" }}
            onChange={(e) => { setSearchWorkItemData({ ...searchWorkItemData, itemName: e.target.value }) }}
            onPressEnter={() => workItemloadData(initPgCfg)}
            placeholder="项目名称"
        />
        <Button onClick={() => workItemloadData()} style={{ margin: "0px 12px 0px 15px" }} shape="round">检索</Button>
        <Button onClick={() => resetWorkItemloadData()} shape="round">重置</Button>
    </div>
    const goItem = () => {
        replaceNav(
            selectedNavId,
            "13-6-1",
            {
                id: "", mode: "add", parentInfo: {
                    mode,
                    selectedNavId,
                    id
                }
            },
            true)
    }
    const title = <>
        <span>待选项目列表</span>
        {/* <PlusSquareOutlined onClick={goItem} style={{ marginLeft: "10px", cursor: "pointer", color: "#6C72F3" }} /> */}
    </>
    return <YHModal
        visible={visible}
        onOk={onOk}
        onCancel={onCancel}
        title="工单管理-选择项目"
        width={'70%'}
        bodyHeight={730}
        showFooter={true}
    >
        <YhBox title={title} rightChildren={rightChildren} style={{ marginBottom: "5px" }}>
            <Table
                bordered
                // size="small"
                rowKey={record => record.id as string}
                rowClassName='editable-row yh-edit-table-tr'
                columns={roleColumns(OPT_TYPE.ADD) as ColumnsType<IItemDetail>}
                dataSource={workItemDataSource}
                pagination={{
                    ...workItemPgCfg,
                    position: ["bottomCenter"],
                    onChange: (pageNum, pageSize) => {
                        workItemloadData({ pageNum, pageSize }).then();
                    }
                }}
                components={components}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
        <YhBox title="已选项目列表">
            <Table
                bordered
                rowKey={record => record.id as string}
                rowClassName='editable-row yh-edit-table-tr'
                columns={roleColumns(OPT_TYPE.REMOVE) as ColumnsType<IItemDetail>}
                dataSource={addDataItemSource}
                pagination={false}
                components={components}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
    </YHModal>
}